export const translation = {
  cz: {
    categoryName: "Kategorie",
    categoryList: "Seznam kategorií",
    addCategory: "+ Přidat kategorii",
    deleteConfirmation: (categoryName: string) =>
      `Opravdu chcete smazat kategorii "${categoryName}"?`,
  },
  en: {
    categoryName: "Category",
    categoryList: "List of categories",
    addCategory: "+ Add Category",
    deleteConfirmation: (categoryName: string) =>
      `Are you sure you want to delete the category "${categoryName}"?`,
  },
  de: {
    categoryName: "Kategorie",
    categoryList: "Kategorienliste",
    addCategory: "+ Kategorie hinzufügen",
    deleteConfirmation: (categoryName: string) =>
      `Sind Sie sicher, dass Sie die Kategorie "${categoryName}" löschen möchten?`,
  },
  es: {
    categoryName: "Categoría",
    categoryList: "Lista de categorías",
    addCategory: "+ Añadir categoría",
    deleteConfirmation: (categoryName: string) =>
      `¿Está seguro de que desea eliminar la categoría "${categoryName}"?`,
  },
  fr: {
    categoryName: "Catégorie",
    categoryList: "Liste des catégories",
    addCategory: "+ Ajouter une catégorie",
    deleteConfirmation: (categoryName: string) =>
      `Êtes-vous sûr de vouloir supprimer la catégorie "${categoryName}" ?`,
  },
  hu: {
    categoryName: "Kategória",
    categoryList: "Kategória lista",
    addCategory: "+ Kategória hozzáadása",
    deleteConfirmation: (categoryName: string) =>
      `Biztosan törölni szeretné a "${categoryName}" kategóriát?`,
  },
  nl: {
    categoryName: "Categorie",
    categoryList: "Categorielijst",
    addCategory: "+ Categorie toevoegen",
    deleteConfirmation: (categoryName: string) =>
      `Weet u zeker dat u de categorie "${categoryName}" wilt verwijderen?`,
  },
  pl: {
    categoryName: "Kategoria",
    categoryList: "Lista kategorii",
    addCategory: "+ Dodaj kategorię",
    deleteConfirmation: (categoryName: string) =>
      `Czy na pewno chcesz usunąć kategorię "${categoryName}"?`,
  },
  ru: {
    categoryName: "Категория",
    categoryList: "Список категорий",
    addCategory: "+ Добавить категорию",
    deleteConfirmation: (categoryName: string) =>
      `Вы уверены, что хотите удалить категорию "${categoryName}"?`,
  },
  sk: {
    categoryName: "Kategória",
    categoryList: "Zoznam kategórií",
    addCategory: "+ Pridať kategóriu",
    deleteConfirmation: (categoryName: string) =>
      `Naozaj chcete odstrániť kategóriu "${categoryName}"?`,
  },
  sv: {
    categoryName: "Kategori",
    categoryList: "Listan över kategorier",
    addCategory: "+ Lägg till kategori",
    deleteConfirmation: (categoryName: string) =>
      `Är du säker på att du vill ta bort kategorin "${categoryName}"?`,
  },
  no: {
    categoryName: "Kategori",
    categoryList: "Liste over kategorier",
    addCategory: "+ Legg til kategori",
    deleteConfirmation: (categoryName: string) =>
      `Er du sikker på at du vil slette kategorien "${categoryName}"?`,
  },
  da: {
    categoryName: "Kategori",
    categoryList: "Liste over kategorier",
    addCategory: "+ Tilføj kategori",
    deleteConfirmation: (categoryName: string) =>
      `Er du sikker på, at du vil slette kategorien "${categoryName}"?`,
  },
  fi: {
    categoryName: "Kategoria",
    categoryList: "Luettelo kategorioista",
    addCategory: "+ Lisää kategoria",
    deleteConfirmation: (categoryName: string) =>
      `Oletko varma, että haluat poistaa kategorian "${categoryName}"?`,
  },
  ar: {
    categoryName: "الفئة",
    categoryList: "قائمة الفئات",
    addCategory: "+ إضافة فئة",
    deleteConfirmation: (categoryName: string) =>
      `هل أنت متأكد أنك تريد حذف الفئة "${categoryName}"؟`,
  },
};

export default translation;
